<script setup lang="ts">
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { activeAccount } = storeToRefs(accountStore);
const { status } = useAuth();
const isLoggedIn = computed(() => status.value === 'authenticated');

const items = computed(() => [{
  label: 'Dashboard',
  icon: 'i-heroicons-home',
  to: `/dashboard`
}, {
  label: 'Tabs',
  icon: 'i-heroicons-table-cells',
  to: `/tabs`,
}, {
  label: 'Templates',
  icon: 'i-heroicons-code-bracket-square',
  to: `/templates`,
// }, {
//   label: 'Use Cases',
//   icon: 'i-heroicons-light-bulb',
//   to: `/use-cases`,
}, {
  label: 'Library',
  icon: 'i-heroicons-puzzle-piece',
  to: `/library`,
}, {
  label: 'Contexts',
  icon: 'i-heroicons-cube-transparent',
  to: `/contexts`,
}, {
  label: 'Settings',
  icon: 'i-heroicons-cog-6-tooth',
  children: [{
    label: 'Credentials',
    icon: 'i-heroicons-key',
    to: `/settings/credentials`,
  }, {
    label: 'Sandbox',
    icon: 'i-heroicons-command-line',
    to: `/settings/sandbox`,
  }, {
    label: 'LLM Settings',
    icon: 'i-heroicons-cpu-chip',
    to: `/settings/llm`,
  }, {
    label: 'LLM Usage',
    icon: 'i-heroicons-chart-bar',
    to: `/settings/llm-usage`,
  }]
},
])

const isAccountLoaded = computed(() => !!activeAccount.value)
</script>

<template>
  <header class="old_mb-4">
    <div class="w-full mx-auto flex items-center px-4 py-1 gap-2 nav-bar">
      <Brand />

      <div v-if="isLoggedIn">
        <UNavigationMenu :items="items" class="w-full justify-center text-base"  />

      </div>
      <!-- <UserAccount v-if="user" :user="user" /> -->
      <div class="flex ml-auto items-center gap-4">
        <!-- <NuxtLink v-if="!user" to="/use-cases" class="text-sm font-medium text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors">Use Cases</NuxtLink> -->
        <AuthButton />
      </div>
      <ColorMode />
    </div>
<!--    <USeparator />-->
  </header>
</template>

